import toastr from 'toastr'
import { dateFormat } from 'filters'
import pagination from 'components/pagination'
import { editableText } from 'components/editable'
import { hasPermits } from 'directives'

const directives = {
  hasPermits
}

const components = {
  pagination,
  editableText,
}

if (!isServer) {
  components.JsonViewer = require('vue-json-viewer').default;
}

const filters = {
  dateFormat
}

const watch = {
  activeTab (n) {
    if (n && this.ancillary && this.ancillary.ancillary_type === "lounge") {
      this.loading = true;
      Promise.all([
        this.loadLoungeReservations(1),
      ]).then(() => {
        this.loading = false;
      });
    }
  },

  testingMode (n) {
    if (this.activeTab && this.ancillary && this.ancillary.ancillary_type === 'lounge') {
      this.loadLoungeReservations(1)
    }
  },

  formData (n, o) {
    if (n == o) return;

    this.form = n;
  }
}


const computed = {
  lounge_reservations () {
    return _.cloneDeep(this.$store.state.channels.active.lounge_reservations || {});
  },

  errors () {
    if (this.$store.state.channels.errors) {
      return this.$store.state.channels.errors.errors;
    }
    return {}
  }
}

const methods = {
  loadLoungeReservations (page = 1) {
    this.loading = true;
    return this.$store.dispatch('channels.getLoungeReservations', {
      id: this.$route.params.id,
      params: {
        page,
        _sort: '-id',
        testing: this.testingMode ? 1 : 0,
      }
    }).then(() => {
      this.loading = false;
    });
  },

  markupValueChanged (event, index) {
    let errors = {};
    this.$emit('throwErrors', errors);
    if (isNaN(event.value)) {
      let key = `channels.${index}.coupon_limit`;
      errors[key] = [];
      errors[key].push("Coupon Limit can only be a number")
      this.$emit('throwErrors', errors);
      return;
    }

    event.startLoading();
    let value = Number(event.value);
    this.formData.ancillaries[index]['markup_value'] = value;

    event.stopLoading();
    event.close();
  },

  reslabFeeValueChanged (event, index) {
    let errors = {};
    this.$emit('throwErrors', errors);
    if (isNaN(event.value)) {
      let key = `channels.${index}.coupon_limit`;
      errors[key] = [];
      errors[key].push("Coupon Limit can only be a number")
      this.$emit('throwErrors', errors);
      return;
    }

    event.startLoading();
    let value = Number(event.value);
    this.formData.ancillaries[index]['reslab_fee_value'] = value;

    event.stopLoading();
    event.close();
  }
}

export default {
  name: 'lounge-ancillary',
  props: ['formData', 'activeTab', 'ancillary', 'ancillaryIndex', 'testingMode'],
  components,
  computed,
  filters,
  methods,
  watch,
  directives,
  data () {
    return {
      loading: false,
      showLoungeReservations: {}
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.activeTab && this.ancillary && this.ancillary.ancillary_type === 'lounge') {
        this.loadLoungeReservations();
      }
    });
  }
} 